import { Equalizer } from './styles'

export const EqualizerIcon = ({ isPlaying }: { isPlaying: boolean }) => (
  <Equalizer $isPlaying={isPlaying}>
    <div className="bar" />
    <div className="bar" />
    <div className="bar" />
    <div className="bar" />
  </Equalizer>
)
